/**
 * FormErrors Component
 * Responsible for showing APPLICATION type errors received from server
 *
 * Params:
 * errors: array of tdWbErrors: the "errors" array property from server error response (ie 400 error)
 * errorKeyNamespace: string: a locale key prefix to translate errors. Translation key will be derived by appending error key to
 * the errorKeyNamespace.
 * usage:
 * html:
 * <td-wb-form-errors [errors]="consumerErrors" errorKeyNamespace="tdWb.form"></td-wb-form-errors>
 *
 * code:
 * <promise>.then(success, (err) => (this.consumerErrors = err.errors);
 */
import {
  Component,
  input
} from '@angular/core';

import { RestErrorType } from '../../../domain/error.domain';

import { TranslatePipe } from '../../../pipes/translate.pipe';
import type { BackendError } from '../../../domain/error.domain';
import type { InterpolateParams } from '../../../pipes/translate.pipe';

@Component({
  selector: 'td-wb-form-errors',
  templateUrl: 'form-errors.component.html',
  imports: [TranslatePipe]
})
export class FormErrorsComponent {
  readonly errors = input<Array<BackendError>>(undefined);
  readonly errorKeyNamespace = input<string>(undefined);

  applicationErrors(): Array<BackendError> {
    const errors = this.errors();
    if (errors !== undefined) {
      return errors.filter((error: BackendError): boolean => error.type === RestErrorType.APPLICATION);
    }
    return [];
  }

  getErrorKey(error: BackendError): string {
    if (error.code !== undefined && error.code !== null) {
      const errorKeyNamespace = this.errorKeyNamespace();
      if (errorKeyNamespace !== undefined && errorKeyNamespace !== null) {
        return `${errorKeyNamespace}.${error.code}`;
      }
      return error.code;
    }
  }

  getErrorKeyParams(error: BackendError): InterpolateParams {
    return error.arguments as unknown as InterpolateParams;
  }

  trackByCode(index: number, item: BackendError): string {
    if (item.code !== undefined && item.code !== null) {
      return item.code;
    }
    return `${index}`;
  }
}
